import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { setLogout } from "../slices/authSlice";

//  Base Query with Env + Headers
const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    // Get token from auth slice state
    const token = getState().auth.token;

    // If we have a token, set the Authorization header
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

// Centralized Error Handling Wrapper
const baseQueryWithErrorHandling = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result?.error) {
    const status = result.error.status;

    // If 401 (Unauthorized), the token is likely expired or invalid
    if (status === 401) {
      console.error("Session expired. Logging out...");
      api.dispatch(setLogout());
      // The application will automatically redirect to /login due to AuthGuard
    }

    if (status >= 500) {
      console.error("Server error");
    }
  }

  return result;
};

export { baseQueryWithErrorHandling };
